import { toast } from "react-hot-toast";

export const validateLoginDetails = (email: string, password: string): boolean => {
    if (!email) {
      toast.error("Kindly tell us your mail");
      return false;
    }

    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    if (!emailRegex.test(email)) {
      toast.error("Your email is not in the correct format");
      return false;
    }

    if (!password) {
      toast.error("We need your password to proceed");
      return false;
    }

    return true;
  };